import Vue from 'vue';
import request from '../../request';

let lastVisitedBookingUrl;

if (localStorage.getItem('lastVisitedBookingUrl') !== null) {
  lastVisitedBookingUrl = localStorage.getItem('lastVisitedBookingUrl');
}

export default {
  namespaced: true,
  state: {
    loading: false,
    isValid: undefined,
    adults: 0,
    children: 0,
    data: [],
    dataSingle: {},
    lastVisitedBookingUrl,
    form: {
      answer: '',
      participants: [],
      occurrence: null,
      promotional_code: null,
    },
    errors: {
      persons: {},
    },
    occurrence: {},
  },
  mutations: {
    setAdults(state, payload) {
      Object.assign(state, { adults: payload });
    },
    setAllParticipants(state) {
      const persons = state.adults + state.children;

      const newParticipants = {};
      for (let i = 1; i <= persons; i += 1) {
        newParticipants[i] = {
          first_name: '',
          last_name: '',
          birth_date: '',
          id_card: '',
        };
      }
      Object.assign(state.form, { participants: newParticipants });
    },
    setChildren(state, payload) {
      Object.assign(state, { children: payload });
    },
    resetPersons(state) {
      Object.assign(state, { adults: 0 });
      Object.assign(state, { children: 0 });
    },
    setIsValid(state, payload) {
      Object.assign(state, { isValid: payload });
    },
    setOccurrence(state, occurrence) {
      Object.assign(state.form, { occurrence });
    },
    setFormValue(state, payload) {
      Object.assign(state.form, payload);
    },
    setParticipantFormValue(state, payload) {
      Object.assign(state.form.participants[payload.index], payload.data);
    },
    setOccurrenceData(state, payload) {
      Vue.set(state, 'occurrence', payload);
    },
    setErrors(state, errors) {
      const newErrors = { persons: {} };
      Object.assign(newErrors, errors);
      Vue.set(state, 'errors', newErrors);
    },
    setBookings(state, data) {
      Vue.set(state, 'data', data);
    },
    setSingleBooking(state, data) {
      Vue.set(state, 'dataSingle', data);
    },
    setLastActivityUrl(state, url) {
      Object.assign(state, { lastVisitedBookingUrl: url });
    },
    setLoading(state, loading) {
      Object.assign(state, { loading });
    },
  },
  actions: {
    setLastBookingUrl(context, url) {
      localStorage.setItem('lastVisitedBookingUrl', url);
      context.commit('setLastBookingUrl', url);
    },
    setAdults(context, payload) {
      context.commit('setAdults', payload);
      context.commit('setAllParticipants');
    },
    setChildren(context, payload) {
      context.commit('setChildren', payload);
      context.commit('setAllParticipants');
    },
    resetPersons(context) {
      context.commit('resetPersons');
    },
    setValid(context, payload) {
      context.commit('setIsValid', payload);
    },
    setOccurrence(context, payload) {
      context.commit('setOccurrence', payload);
    },
    setFormValue(context, payload) {
      context.commit('setFormValue', payload);
    },
    setParticipantFormValue(context, payload) {
      context.commit('setParticipantFormValue', payload);
    },
    getOccurrence(context, payload) {
      const url = `${process.env.API_URL}activity_calendar_occurrence/${payload.occurrence_id}`;
      request.make({
        type: 'GET',
        url,
        data: { activity_id: payload.activity_id },
      }, (err, res) => {
        if (res.status === 200) {
          context.commit('setOccurrenceData', res.body.data);
        }
      });
    },
    get(context, payload) {
      return new Promise((resolve) => {
        const username = context.rootState.user.data.username;
        const url = `${process.env.API_URL}activity_booking`;
        const data = { username };
        if (typeof payload !== 'undefined' && payload !== null) {
          if (typeof payload.has_been_paid !== 'undefined') {
            data.has_been_paid = payload.has_been_paid;
          }
        }
        context.commit('setLoading', true);
        request.make({
          type: 'GET',
          url,
          data,
        }, (err, res) => {
          context.commit('setLoading', false);
          if (res.status === 200) {
            context.commit('setBookings', res.body.data);
            resolve();
          }
          if (res.status === 404) {
            context.commit('setBookings', []);
            resolve();
          }
        });
      });
    },
    getSingle(context, id) {
      const url = `${process.env.API_URL}activity_booking/${id}`;
      request.make({
        type: 'GET',
        url,
        data: {},
      }, (err, res) => {
        if (res.status === 200) {
          context.commit('setSingleBooking', res.body.data);
        }
      });
    },
    book(context) {
      return new Promise((resolve) => {
        const data = {};
        data.occurrence_id = context.state.form.occurrence;
        data.aditional_info_response = context.state.form.answer;
        data.promotional_code = context.state.form.promotional_code;
        if (Object.keys(context.state.form.participants).length >= 0) {
          data.persons = [];
          Object.keys(context.state.form.participants).forEach((key) => {
            const participant = context.state.form.participants[key];
            data.persons.push({
              first_name: participant.first_name,
              last_name: participant.last_name,
              birthday: participant.birth_date,
              id_card_number: participant.id_card,
            });
          });
        }
        request.make({
          url: `${process.env.API_URL}activity_booking`,
          type: 'POST',
          data,
        }, (err, res) => {
          if (res.statusCode === 422) {
            context.commit('setErrors', res.body.errors);
            context.dispatch('setShowAllValidationErrors', true, { root: true });
            context.dispatch('showSaveError', undefined, { root: true });
            // reject();
          }
          if (res.statusCode === 204) {
            context.dispatch('setShowAllValidationErrors', false, { root: true });
            context.dispatch('showSaveSuccess', undefined, { root: true });
            context.commit('setErrors', {});
            context.dispatch('get');
            resolve();
          }
        });
      });
    },
    cancel(context, code) {
      return new Promise((resolve) => {
        request.make({
          type: 'PUT',
          url: `${process.env.API_URL}activity_booking`,
          data: { cancel: true, code },
        }, (err, res) => {
          if (res.statusCode === 204) {
            context.dispatch('showSaveSuccess', undefined, { root: true });
            context.dispatch('get');
            resolve();
          }
        });
      });
    },
  },
  getters: {
    totalUnpaid(state) {
      // Total unpaid is a price not a count of bookings
      if (state.data.length === 0) {
        return 0;
      }
      let total = 0;
      state.data.forEach((booking) => {
        if (booking.has_outstanding_payment === true) {
          total += booking.charging_value;
        }
      });
      return total;
    },
    totalUnpaidCount(state) {
      // Total unpaid is a price not a count of bookings
      if (state.data.length === 0) {
        return 0;
      }
      let count = 0;
      state.data.forEach((booking) => {
        if (booking.has_outstanding_payment === true) {
          count += 1;
        }
      });
      return count;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/public/booking.js